import { useMemo } from 'react';
import { useQueryResourceRootList } from './useQueryResourceRootList.js';
import { useQueryFolderLabels } from '../../labels/queries/useQueryFolderLabels.js';
import { convertResourceRootToSpace } from '../../spaces/utils/convertSpaceRootToSpace.js';

const useQueryResourceRoot = (resourceRootId) => {
  const query = useQueryResourceRootList();
  const { data: labels } = useQueryFolderLabels(resourceRootId);
  const resourceRoot = useMemo(() => {
    if (!resourceRootId) {
      return void 0;
    }
    return query.roots?.find((root) => root.id === resourceRootId);
  }, [
    resourceRootId,
    query.roots
  ]);
  return {
    isLoading: query.isLoading,
    error: query.error,
    resourceRoot,
    labels,
    /**
    * helper shape to transition to new resource root
    * @deprecated use `resourceRoot` shape directly
    */
    asLegacySpace: useMemo(() => {
      if (resourceRoot) {
        const result = {
          ...convertResourceRootToSpace(resourceRoot),
          labels
        };
        return result;
      }
      return void 0;
    }, [
      resourceRoot,
      labels
    ])
  };
};

export { useQueryResourceRoot };
//# sourceMappingURL=useQueryResourceRoot.js.map
